import { useFormContext } from "react-hook-form";
import InputText from "../../components/InputText";
import PhoneNumberField from "../../components/PhoneNumberField";
import EmailField from "../../components/EmailField";
import AddressInput from "../../components/AddressInput";

function CustomerInfromation() {
  const { control, setValue, getValues, register } = useFormContext();

  return (
    <div className="max-w-[700px] w-full mx-auto grid gap-y-10">
      <div className="grid gap-y-3">
        <h3 className="text-gray-900 font-semibold">Customer Information</h3>
        <div className="grid min-[540px]:grid-cols-2 grid-cols-1 gap-x-4 gap-y-3">
          <InputText
            control={control}
            name="first_name"
            type="text"
            label="First Name"
            required
          />
          <InputText
            control={control}
            name="last_name"
            type="text"
            label="Last Name"
            required
          />
          <EmailField
            control={control}
            name="email"
            label="Email Address"
            className="bg-gray-50"
            required
          />
          <PhoneNumberField
            control={control}
            name="customer_primary_telephone"
            label="Primary Telephone"
            className="bg-gray-50"
            required
          />
          <InputText
            control={control}
            name="customer_id"
            type="text"
            label="Customer ID"
          />
          <PhoneNumberField
            control={control}
            name="customer_alternative_telephone"
            label="Alternative Telephone"
            className="bg-gray-50"
          />
        </div>
      </div>
      <div className="grid gap-y-3">
        <h3 className="text-gray-900 font-semibold">Customer Address</h3>
        <div className="grid min-[540px]:grid-cols-2 grid-cols-1 gap-x-4 gap-y-3">
          <AddressInput
            control={control}
            name="customerAddress.address"
            onAddressSelect={(address) => {
              setValue("customerAddress.city", address.city);
              setValue("customerAddress.state", address.state);
              setValue("customerAddress.zip_code", address.zipCode);
            }}
            label="Street Address"
            required
          />
          <InputText
            control={control}
            name="customerAddress.address_2"
            type="text"
            label="Address Line 2"
          />
          <div className="min-[600px]:col-span-2 max-[600px]:grid-cols-2 grid-cols-4  grid gap-x-4 gap-y-3">
            <InputText
              control={control}
              name="customerAddress.city"
              required
              label="City"
            />
            <InputText
              control={control}
              name="customerAddress.state"
              required
              label="State/Province"
            />
            <InputText
              control={control}
              name="customerAddress.zip_code"
              required
              label="Postal Code"
            />
            <InputText
              control={control}
              name="customerAddress.country_code"
              required
              defaultValue="USA"
              label="Country Code"
              inputProps={{
                maxLength: 3,
              }}
            />
          </div>
        </div>
      </div>
      <div className="grid gap-y-3">
        <div>
          <h3 className="text-gray-900 font-semibold">Delivery Address</h3>
          <span className="flex gap-2 text-gray-500 m-0 p-0 text-sm">
            <input
              type="checkbox"
              name="is_same_address"
              {...register("is_same_address", {
                onChange: (e) => {
                  if (e.target.checked) {
                    setValue(
                      "deliveryAddress.address",
                      getValues("customerAddress.address")
                    );
                    setValue(
                      "deliveryAddress.address_2",
                      getValues("customerAddress.address_2")
                    );
                    setValue(
                      "deliveryAddress.city",
                      getValues("customerAddress.city")
                    );
                    setValue(
                      "deliveryAddress.state",
                      getValues("customerAddress.state")
                    );
                    setValue(
                      "deliveryAddress.zip_code",
                      getValues("customerAddress.zip_code")
                    );
                    setValue(
                      "deliveryAddress.country_code",
                      getValues("customerAddress.country_code")
                    );
                  }
                },
              })}
            />
            <p>Same as Customer Address</p>
          </span>
        </div>
        <div className="grid min-[540px]:grid-cols-2 grid-cols-1 gap-x-4 gap-y-3">
          <AddressInput
            control={control}
            name="deliveryAddress.address"
            onAddressSelect={(address) => {
              setValue("deliveryAddress.city", address.city);
              setValue("deliveryAddress.state", address.state);
              setValue("deliveryAddress.zip_code", address.zipCode);
            }}
            label="Street Address"
          />
          <InputText
            control={control}
            name="deliveryAddress.address_2"
            type="text"
            label="Address Line 2"
          />
          <div className="min-[600px]:col-span-2 max-[600px]:grid-cols-2 grid-cols-4  grid gap-x-4 gap-y-3">
            <InputText
              control={control}
              name="deliveryAddress.city"
              label="City"
            />
            <InputText
              control={control}
              name="deliveryAddress.state"
              label="State/Province"
            />
            <InputText
              control={control}
              name="deliveryAddress.zip_code"
              label="Postal Code"
            />
            <InputText
              control={control}
              name="deliveryAddress.country_code"
              label="Country Code"
              defaultValue="USA"
              inputProps={{
                maxLength: 3,
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default CustomerInfromation;
